import {
  STOCK_GET_FOTO_MINIATURA_BEGIN,
  STOCK_GET_FOTO_MINIATURA_SUCCESS,
  STOCK_GET_FOTO_MINIATURA_FAILURE,
  STOCK_GET_FOTO_MINIATURA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { REACT_APP_IMG } from '../../../common/config';
import { encodeImageUrl } from '../../common/Utilities';
import { CAR_NOT_FOUND_THUMB } from '../../../common/assets'
import { FILES_ENDPOINT } from '../../../common/endpoints'

export function getFotoMiniatura({ idProducto }) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: STOCK_GET_FOTO_MINIATURA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {

      const doRequest = axios(FILES_ENDPOINT + '/PRODUCTO/' + idProducto)

      doRequest.then(
        (res) => {
          let image
          if (res.data.data.length > 0) {
            let fotos = []
            res.data.data.forEach((file) => {
              if (file.type.name.search(/^image\//i) !== -1) {
                fotos.push(`${REACT_APP_IMG}/${encodeURIComponent(file.url)}`)
              }
            })
            if (fotos.length > 0) {
              image = fotos[0]
            } else {
              // CAR_NOT_FOUND_THUMB
              image = encodeImageUrl(CAR_NOT_FOUND_THUMB)
            }
          } else {
            //Reemplazar esta imagen por una de nuestra CDN
            image = encodeImageUrl(CAR_NOT_FOUND_THUMB)
          }
          dispatch({
            type: STOCK_GET_FOTO_MINIATURA_SUCCESS,
            data: image,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: STOCK_GET_FOTO_MINIATURA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetFotoMiniaturaError() {
  return {
    type: STOCK_GET_FOTO_MINIATURA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_GET_FOTO_MINIATURA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getFotoMiniaturaPending: true,
        getFotoMiniaturaError: null,
      };

    case STOCK_GET_FOTO_MINIATURA_SUCCESS:
      // The request is success
      return {
        ...state,
        fotoMiniatura: action.data,
        getFotoMiniaturaPending: false,
        getFotoMiniaturaError: null,
      };

    case STOCK_GET_FOTO_MINIATURA_FAILURE:
      // The request is failed
      return {
        ...state,
        getFotoMiniaturaPending: false,
        getFotoMiniaturaError: action.data.error,
      };

    case STOCK_GET_FOTO_MINIATURA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getFotoMiniaturaError: null,
      };

    default:
      return state;
  }
}
